import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    contentContainer: {
      textAlign: 'center',
    },
    heading: {
      fontSize: 32,
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.h3.fontSize,
      },
    },
    overlay: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: theme.palette.background.contrast,
      [theme.breakpoints.up('sm')]: {
        background: `radial-gradient(50% 50% at 50% 50%, ${theme.palette.background.contrast} 0%, rgba(249, 246, 243, 0.9) 100%)`,
      },
    },
    subHeading: {
      padding: theme.spacing(3),
      maxWidth: '500px',
      fontSize: theme.typography.subtitle1.fontSize,
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.h5.fontSize,
      },
    },
    subtextContainer: {
      margin: theme.spacing(3, 0),
      maxWidth: '300px',
      color: theme.palette.grey[700],
      fontSize: 12,
      position: 'fixed',
      left: '50%',
      bottom: '0%',
      transform: 'translate(-50%)',
      width: '60%',
      lineHeight: '24px',
      [theme.breakpoints.up('sm')]: {
        margin: `${theme.spacing(6)}px auto`,
        position: 'relative',
        left: 0,
        bottom: 'auto',
        transform: 'none',
        fontSize: 14,
      },
    },
    wrapper: {
      margin: '0 auto',
      width: '50px',
      height: '50px',
      overflow: 'hidden',
      [theme.breakpoints.up('sm')]: {
        width: '75px',
        height: '75px',
      },
    },
    background: {
      height: '100%',
      position: 'relative',
      background: 'radial-gradient(at center top, #E06031, #FFD103)',
    },
    mask: {
      width: '150%',
      height: '150%',
      top: '-25%',
      left: '-25%',
      position: 'relative',
      background: theme.palette.background.contrast,
      maskImage:
        'url("//images.babylist.com/image/upload/v1685458357/DME/rainbow-mask.png")',
      maskRepeat: 'no-repeat',
      maskSize: '100%',
      maskPosition: 'center',
      animation: '$rotate 1.75s ease-in-out infinite',
    },
    '@keyframes rotate': {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    },
    arch: {
      position: 'absolute',
      zIndex: -1,
      bottom: '2%',
      left: '4%',
    },
    burst: {
      position: 'absolute',
      zIndex: -1,
      right: 0,
      bottom: '20%',
    },
    vector: {
      position: 'absolute',
      zIndex: -1,
      left: 0,
      top: '10%',
    },
    clover: {
      position: 'absolute',
      zIndex: -1,
      top: '0%',
      right: '0%',
    },
  })
)
